var map = {
	"./ergediandian-sp.webp": "e31e",
	"./ergediandian.webp": "b837",
	"./koudai.webp": "65d2",
	"./migu-music.webp": "45c3",
	"./netease-cloud-music.webp": "6936",
	"./qq-music.webp": "7bad",
	"./word-world.webp": "bdb6",
	"./ximalaya.webp": "0929",
	"./youxuepai.webp": "791d",
	"./yunting.webp": "ead0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d369";